{
  "#PASSWORD": {
    "TITLE": "Passwort vergessen?",
    "COMPONENTS": {
      "USER_FORM": {
        "TITLE": "Passwort vergessen",
        "STEP1": "Schritt 1/2: Bestätigungscode anfordern",
        "USERNAME": "Benutzername",
        "EMAIL": "Email Adresse",
        "INFO": "Mit einem Klick auf 'Bestätigungscode anfordern' erhalten Sie eine Email an die angegebene Adresse (sofern diese mit dem angegebenen Benutzerkonto verknüpft ist). Klicken Sie auf den darin enthaltenen Link um die Wiederherstellung Ihres Passworts fortzusetzen.",
        "SUBMIT": "Bestätigungscode anfordern"
      },
      "RESET_FORM": {
        "TITLE": "Passwort vergessen",
        "STEP2": "Schritt 2/2: Passwort wiederherstellen",
        "TOKEN": "Bestätigungscode",
        "PASSWORD": "Neues Passwort",
        "USERNAME": "Benutzername: ",
        "PASSWORD_REPEAT": "Neues Passwort (wiederholung)",
        "SUBMIT": "Passwort ändern"
      }
    },
    "MESSAGES": {
      "CONFIRMATION_SENT": "Eine Nachricht mit dem Bestätigungscode wurde an die angegebene Email-Adresse geschickt.",
      "RESET_SUCCESS": "Ihr Passwort wurde erfolgreich gesetzt",
      "RESET_FAILURE": "Ihr Passwort konnte nicht zurückgesetzt werden",
      "CONFIRMATION_FAILED": "Es konnte kein Bestätigungscode versendet werden"
    },
    "VALIDATION": {
      "PASSWORD": {
        "MIN_LENGTH": "Muss mindestens {{requiredLength}} Zeichen lang sein",
        "MIN_LENGTH_MESSAGE": "Aktuell: {{actualLength}}",
        "UPPERCASE": "Muss mindestens einen Großbuchstaben enthalten",
        "LOWERCASE": "Muss mindestens einen Kleinbuchstaben enthalten",
        "NUMBER": "Muss mindestens eine Zahl enthalten",
        "SYMBOL": "Muss mindestens ein Sonderzeichen enthalten",
        "OPTIONAL": "(optional)"
      },
      "PASSWORD_REPEAT": {
        "UNEQUAL": "Die Passwörter stimmen nicht überein!"
      }
    },
    "SETTINGS": {
      "TITLE": "Passwort ändern",
      "STEP1": "Schritt 1: Bestätigungscode anfordern",
      "STEP2": "Schritt 2: Passwort ändern",
      "EMAIL": "Email Adresse",
      "TOKEN": "Bestätigungscode",
      "PASSWORD": "Neues Passwort",
      "PASSWORD_REPEAT": "Neues Password (wiederholung)",
      "SEND_TOKEN": "Bestätigungscode anfordern",
      "CHANGE_PASSWORD": "Passwort ändern"
    }
  }
}
